module.exports = __webpack_public_path__ + "static/media/CTLA_3-178w.74c07b91.jpg";